import { createListenerMiddleware } from '@reduxjs/toolkit'
import {
  updateNotificationPreferences,
  fetchNotificationPreferences,
} from './profile.slice'

export let listenerMiddleware = createListenerMiddleware()

listenerMiddleware.startListening({
  actionCreator: updateNotificationPreferences.fulfilled,
  effect: async (action, listenerApi) => {
    listenerApi.dispatch(fetchNotificationPreferences())
  },
})
